import { render, staticRenderFns } from "./ManageEnvelope.vue?vue&type=template&id=06a19a25&"
import script from "./ManageEnvelope/ManageEnvelope.js?vue&type=script&lang=js&"
export * from "./ManageEnvelope/ManageEnvelope.js?vue&type=script&lang=js&"
import style0 from "./ManageEnvelope/ManageEnvelope.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports